import React from 'react';
import { Alert, Button } from 'reactstrap';

type FullPageErrorProps = {
    message: string;
    onRetry?: () => void;
};

export default function FullPageError({ message, onRetry }: FullPageErrorProps) {
    return (
        <Alert color="danger">
            <i className="ion-md-warning me-2" aria-hidden="true" />
            {message}
            {onRetry && (
                <>
                    {' '}
                    <Button size="sm" color="primary" onClick={onRetry}>
                        Try again
                    </Button>
                </>
            )}
        </Alert>
    );
}
